import { Grid } from '@mui/material';
import { useState } from 'react';
import NewOptOutsOverTimeCard from './cards/NewOptOutsOverTimeCard';
import NewSubsOverTimeCard from './cards/NewSubsOverTimeCard';
import SMSMetricsBySendCards from './cards/SMSMetricsBySendCards';
import SMSStatsCards from './cards/SMSStatsCards';
import TotalSendsOverTimeCard from './cards/TotalSendsOverTimeCard';
import DashboardHeader from '../DashboardHeader';
import { sixMonthsAgo, today } from '../filtering/DateFilter/DateFilter';
import { FiltersForApiState, FilterValuesState } from '../filtering/types';
import { getTimeframeForApi } from '../filtering/utils';
import Filters from './Filters';
import useDownloadQuery from 'hooks/useDownloadQuery/useDownloadQuery';
import { CuredApiPaths, DashboardNames, DownloadQueryKeys, ApiMethods } from 'models/enums';
import DashboardDownloadSnackbar from 'pages/InsightsPage/dashboards/DashboardDownloadSnackbar';

const SMSDashboard = () => {
    const end = today;
    const start = sixMonthsAgo;
    // This state value is tracking the input values of the fields used for filtering.
    const [filterValues, setFilterValues] = useState<FilterValuesState>({
        selectedCurationsValue: [],
        filterTimeframe: { start, end },
        filterRelativeTimeframe: {
            direction: null,
            duration: null,
            unit: null,
        },
    });
    const [isRelativeTimeframe, setIsRelativeTimeframe] = useState(false);

    const campaignsForApi = filterValues.selectedCurationsValue?.map((curation) => curation?.campaign_id);
    const timeframeForApi = getTimeframeForApi(isRelativeTimeframe, filterValues);

    // This state value is tracking what's sent to the API for filtering, which may not
    // match the field values as filters are not applied until a button is clicked.
    const [filtersForApi, setFiltersForApi] = useState<FiltersForApiState>({
        campaigns: campaignsForApi,
        timeframe: timeframeForApi,
    });

    const { downloadFile, isDownloading, isSuccess, error, resetDownloadState } = useDownloadQuery(
        DownloadQueryKeys.SMS_DASHBOARD,
        CuredApiPaths.REPORT_SMS_DOWNLOAD,
        ApiMethods.POST
    );

    // This handles clicking on the button to apply filters by setting the filtersForApi
    // state to match the input state values.
    const handleApplyFilters = () => {
        setFiltersForApi({
            campaigns: campaignsForApi,
            timeframe: timeframeForApi,
        });
    };

    // This function will handle the API call to get the downloadable report according to the
    // filters applied in the current state.
    const handleDownloadClick = () => {
        downloadFile({ filtersForApi: filtersForApi });
    };

    return (
        <div style={{ paddingBottom: '32px' }}>
            <DashboardDownloadSnackbar
                isDownloading={isDownloading}
                isSuccess={isSuccess}
                error={error}
                dashboardName={DashboardNames.TEXT_MESSAGE}
                onSuccessClosed={resetDownloadState}
                onErrorClosed={resetDownloadState}
            />
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Filters
                        filterValues={filterValues}
                        handleApplyFilters={handleApplyFilters}
                        isRelativeTimeframe={isRelativeTimeframe}
                        setFilterValues={setFilterValues}
                        setIsRelativeTimeframe={setIsRelativeTimeframe}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DashboardHeader
                        title="text messaging"
                        subtitle="take action with cured insights"
                        description="Filter on specific text message Curations to quickly identify what's working to improve future sends."
                        handleDownloadClick={handleDownloadClick}
                    />
                </Grid>
                <SMSStatsCards filtersForApi={filtersForApi} />
                <Grid item xs={12}>
                    <NewSubsOverTimeCard filtersForApi={filtersForApi} />
                </Grid>
                <Grid item xs={12}>
                    <TotalSendsOverTimeCard filtersForApi={filtersForApi} />
                </Grid>
                <Grid item xs={12}>
                    <NewOptOutsOverTimeCard filtersForApi={filtersForApi} />
                </Grid>
                <Grid item xs={12}>
                    <SMSMetricsBySendCards filtersForApi={filtersForApi} />
                </Grid>
            </Grid>
        </div>
    );
};

export default SMSDashboard;
